module.exports = __webpack_public_path__ + "img/miesasetteleekuviaseinalle.28d18a35.webp";